import { getSizeSettings } from "../../../utils/get-size-settings";
import { ViewObjectContainerParser } from "../view-object-container-parser";
import { SettingsParser } from "../settings-parser";
import { ColumnGridSettings } from "../../settings/view-objects/column-grid-settings";

export class ColumnGridSettingsParser extends ViewObjectContainerParser {
  constructor(viewObjectParsers) {
    super(viewObjectParsers);
    this.parsedFieldNames.push("columnsSpace");
    this.parsedFieldNames.push("columns");
  }

  static createSettings(settings, defaultSettings, viewObjectParsers) {
    let parsedSettings = ViewObjectContainerParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    let defaultViewObjects = settings._defaultViewObjects;
    parsedSettings.columnsSpace = getSizeSettings(settings.columnsSpace ?? defaultSettings?.columnsSpace, 0, 0);
    if (settings.columns !== undefined) {
      parsedSettings.columns = [];
      for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
        let columnSettings = settings.columns[columnIndex];
        let columnInfo = {
          width: getSizeSettings(columnSettings.width ?? defaultSettings?.columnSettings?.width, 0, 1),
          rowsSpace: getSizeSettings(columnSettings.rowsSpace ?? defaultSettings?.columnSettings?.rowsSpace, 0, 0),
          rows: []
        };
        for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
          let rowSettings = columnSettings.rows[rowIndex];
          columnInfo.rows.push({
            height: getSizeSettings(rowSettings.height ?? defaultSettings?.rowSettings?.height, 0, 1),
            item: ViewObjectContainerParser.parseItem(rowSettings.item, viewObjectParsers, defaultViewObjects)
          });
        }
        parsedSettings.columns.push(columnInfo);
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = ColumnGridSettingsParser.createSettings(settings, defaultSettings, this.viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new ColumnGridSettings(parsedSettings);
  }
}
